import { render } from "./LoadableImage.vue?vue&type=template&id=5d86f5e6&scoped=true"
import script from "./LoadableImage.vue?vue&type=script&lang=ts"
export * from "./LoadableImage.vue?vue&type=script&lang=ts"

import "./LoadableImage.vue?vue&type=style&index=0&id=5d86f5e6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5d86f5e6"

export default script